import { ModalData } from 'models/ModalData';

export const ModalActionType = {
    SHOW_MODAL: "SHOW_MODAL",
    CLOSE_MODAL: "CLOSE_MODAL"
};

interface IShowModalAction {
    type: typeof ModalActionType.SHOW_MODAL,
    modalData: ModalData
}

interface ICloseModalAction {
    type: typeof ModalActionType.CLOSE_MODAL,
    modalData: ModalData | null
}

export type IModalActions = IShowModalAction | ICloseModalAction

export class ModalActions {
    public static showModal(modalData: ModalData): ModalActions {
        return {
            type: ModalActionType.SHOW_MODAL,
            modalData: modalData
        }
    }

    public static closeModal(): ModalActions {
        return {
            type: ModalActionType.CLOSE_MODAL,
            modalData: null
        }
    }
}

